import { useState, useEffect } from 'react'
import axios from 'src/utilities/http-client'
import { LiveClassScheduleResponse } from '../types'

interface UseScheduleDataResult {
  scheduleData: LiveClassScheduleResponse | null
  loading: boolean
  error: string | null
  refetch: () => void
}

export let useScheduleData = (weekStart?: string): UseScheduleDataResult => {
  let [scheduleData, setScheduleData] =
    useState<LiveClassScheduleResponse | null>(null)
  let [loading, setLoading] = useState(true)
  let [error, setError] = useState<string | null>(null)

  let fetchScheduleData = async () => {
    try {
      setLoading(true)
      setError(null)

      let url = weekStart
        ? `/api/live-class/event/schedule?week=${weekStart}`
        : '/api/live-class/event/schedule'

      let response = await axios.get<LiveClassScheduleResponse>(url)
      setScheduleData(response.data)
    } catch (err: any) {
      if (err.response?.status === 401) {
        setError('Authentication required. Please log in.')
      } else if (err.response?.status === 500) {
        setError('Server error. Please try again later.')
      } else {
        setError('Failed to load schedule data.')
      }
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchScheduleData()
  }, [weekStart])

  return {
    scheduleData,
    loading,
    error,
    refetch: fetchScheduleData,
  }
}
